import { Action } from '../../actions';
import { UPDATE_INTERNAL_PRODUCT_PLACES } from '../../actions/places/internal/updateInternalProductPlaces';
import { InternalProductPlacesState } from '../../typings/internalProductPlace';

import { updateInternalProductPlaces } from './internal/updateInternalProductPlaces';

export const getInternalProductPlacesInitialState = (): InternalProductPlacesState => ({
    places: []
});

export function internalProductPlaces(
    state: InternalProductPlacesState = getInternalProductPlacesInitialState(),
    action: Action
): InternalProductPlacesState {
    switch (action.type) {
        case UPDATE_INTERNAL_PRODUCT_PLACES:
            return updateInternalProductPlaces(state, action);

        default:
            return state;
    }
}
